import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule as CoreSharedModule } from '../core/shared/shared.module';
import { TrackScrollEventsDirective } from './event-tracking/scroll-tracking/scroll-tracking.directive';
import { AgentsPerStepComponent } from './misc-components/agents-per-step.component';
import { SecondsToTimePipe } from './seconds-to-time.pipe';

const exportedComponents = [
  AgentsPerStepComponent,
  SecondsToTimePipe,
  TrackScrollEventsDirective,
];

@NgModule({
  imports: [
    CommonModule,
    CoreSharedModule,
    FontAwesomeModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  declarations: [exportedComponents],
  exports: [exportedComponents, CoreSharedModule],
})
export class SharedModule {}
